
// import translations
import { LANG_EN_NAME, LANG_EN_TRANS } from './lang-en';
import { LANG_ML_NAME, LANG_ML_TRANS } from './lang-ml';
import { LANG_TA_NAME, LANG_TA_TRANS } from './lang-ta';
import { LANG_KN_NAME, LANG_KN_TRANS } from './lang-kn';
import { InjectionToken } from '@angular/core';

// translation token
export const TRANSLATIONS = new InjectionToken('translations');

// all traslations
export const dictionary = {
    [LANG_EN_NAME]: LANG_EN_TRANS,
    [LANG_ML_NAME]: LANG_ML_TRANS,
    [LANG_TA_NAME]: LANG_TA_TRANS,
    [LANG_KN_NAME]: LANG_KN_TRANS,
};

// providers
export const TRANSLATION_PROVIDERS = [
    { provide: TRANSLATIONS, useValue: dictionary },
];
